import React from "react";

export default function Footer() {
  return (
    <div className="container-fluid text-light bg-secondary">
      <div className="footer">© Copyright InfoNation</div>
    </div>
  );
}
